import React, { Component } from 'react'
import { Container, Input, Card } from 'semantic-ui-react'
import CustomCards from './card'
import AppHeader from './header'

class SemanticCards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            GeometryInfoArray: []
        };
    }

    onProjectsQueried(data) {
        if (data.data) {
            if (this.state.LastEvalKey) {
                let geometryInfoArray = this.state.GeometryInfoArray;
                this.setState({
                    GeometryInfoArray: geometryInfoArray.concat(data.data.Items),
                    QueryBy: 'ViewCount'
                });
            } else {
                this.setState({
                    GeometryInfoArray: data.data.Items,
                    QueryBy: 'ViewCount'
                });
            }

            if (data.data.LastEvalKey) {
                this.setState({ LastEvalKey: data.data.LastEvalKey });
            } else {
                if (this.state.LastEvalKey) {
                    this.setState({ EndReached: true });
                }
                this.setState({ LastEvalKey: null });
            }

            document.addEventListener('scroll', this.trackScrolling);
        }
    }

    queryProjects(freshStart) {
        let sendData = {
            "action": "query-projects",
            "data": {
                "QueryBy": "ViewCount",
                "Limit": 15
            }
        }
        if (!freshStart && this.state.LastEvalKey) {
            sendData.data.StartKey = this.state.LastEvalKey;
        }

        this.props.webSocketClient.run(sendData, this.onProjectsQueried.bind(this))
    }

    onChangeSearch() {
        const searchInput = document.getElementById('search');
        const searchStr = searchInput.value;
        this.setState({
            searchStr: searchStr,
            LastEvalKey: null,
            EndReached: null
        })
        if (searchStr === '') {
            this.queryProjects(true);
        } else {
            this.searchProjects(searchStr, true);
        }
    }

    onProjectsSearched(data) {
        if (data.data) {
            if (this.state.LastEvalKey) {
                let geometryInfoArray = this.state.GeometryInfoArray;
                this.setState({
                    GeometryInfoArray: geometryInfoArray.concat(data.data.Items),
                    QueryBy: 'Name'
                });
            } else {
                this.setState({
                    GeometryInfoArray: data.data.Items,
                    QueryBy: 'Name'
                });
            }

            if (data.data.LastEvalKey) {
                this.setState({ LastEvalKey: data.data.LastEvalKey });
            } else {
                if (this.state.LastEvalKey) {
                    this.setState({ EndReached: true });
                }
                this.setState({ LastEvalKey: null });
            }

            document.addEventListener('scroll', this.trackScrolling);
        }
    }

    searchProjects(searchStr, freshStart) {
        let sendData = {
            "action": "query-projects",
            "data": {
                "QueryBy": "Name",
                "Limit": 10,
                "Name": searchStr
            }
        }
        if (!freshStart && this.state.LastEvalKey) {
            sendData.data.StartKey = this.state.LastEvalKey;
        }

        this.props.webSocketClient.run(sendData, this.onProjectsSearched.bind(this))
    }

    componentDidMount() {
        window.gtag('config', 'UA-138495762-1', {'page_path': window.location.pathname + window.location.search});
        this.props.changeHomePageState();
        this.queryProjects();
        document.addEventListener('scroll', this.trackScrolling);
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.trackScrolling);
    }

    trackScrolling = () => {
        const wrappedElement = document.getElementById('container');
        if (this.isBottom(wrappedElement)) {
            if (!this.state.EndReached) {
                if (this.state.QueryBy === 'Name') {
                    this.searchProjects();
                } else {
                    this.queryProjects();
                }
            }
            document.removeEventListener('scroll', this.trackScrolling);
        }
    }

    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight * 2;
    }

    render() {
        return (
            <div id="container">
                {/* <AppHeader></AppHeader> */}
                <div className={'shbg-grey-pallet threehundred ui segment stackable grid no-border no-padding no-margin no-radius no-shadow'}>
                    <div className={'row no-margin no-padding'}>
                        <div className={'sixteen wide mobile sixteen wide tablet sixteen wide computer column no-margin no-padding'}>
                            <div className={'container-fluid responsive-padding padding-large'} style={{ paddingBottom: '0rem'}}>
                                <div className={'content-block vertical-align-middle'}>
                                    <div className={'inner-content custom-section-width sixteen-wide position-center text-align-center container-limit max-width-boxed-layout-extra-large'}>                                        
                                        <div>
                                            <Input style={{ width: '100%', maxWidth: '500px'}} id="search" icon='search' iconPosition='left' placeholder='Search project...' onChange={this.onChangeSearch.bind(this)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'sixteen wide mobile sixteen wide tablet sixteen wide computer column no-margin no-padding'}>
                            <div className={'container-fluid responsive-padding padding-large'}>
                                <div className={'content-block vertical-align-top'}>
                                    <div className={'inner-content custom-section-width sixteen-wide position-center container-limit max-width-boxed-layout-extra-large'}>
                                        <div className={'ui centered grid'}>
                                            <div className={'row'}>
                                                <CustomCards GeometryInfo={{
                                                    DisplayName: 'Create New',
                                                    ThumbnailUrl: require('../images/cards/createYourOwn2.png'),
                                                }} onClick={this.props.onClick} ></CustomCards>
                                                {this.state.GeometryInfoArray.map((geometryInfo, i) => {
                                                    return <CustomCards GeometryInfo={geometryInfo} key={i} id={i} ></CustomCards>;
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SemanticCards;